import useTypedContext from "hooks/useTypedContext";
import Stepper from "ds/components/Stepper";
import StepperStep from "ds/components/Stepper/Step";
import StepperStepsGroup from "ds/components/Stepper/StepsGroup";
import StepperHeader from "ds/components/Stepper/Header";

import { ContextFormContext } from "../context";
import { contextCreationWizardNavSteps } from "../constants";

const NewContextStepper = () => {
  const { currentStep, setCurrentStep } = useTypedContext(ContextFormContext);

  return (
    <Stepper>
      <StepperHeader>Follow the steps</StepperHeader>
      <StepperStepsGroup>
        {contextCreationWizardNavSteps.map((item, index) => (
          <StepperStep
            key={item.step}
            active={item.step === currentStep}
            onClick={index < currentStep ? () => setCurrentStep(item.step) : undefined}
            disabled={index > currentStep}
          >
            {item.name}
          </StepperStep>
        ))}
      </StepperStepsGroup>
    </Stepper>
  );
};

export default NewContextStepper;
